"use client"

import { useEffect, useState } from "react";

const useSearchDebounce = (value = '', delay = 350) => {
  const [search, setSearch] = useState(value);
  const [searchQuery, setSearchQuery] = useState(null);

  useEffect(() => {
    const delayFn = setTimeout(() => setSearch(searchQuery), delay);
    return () => clearTimeout(delayFn);
  }, [searchQuery, delay]);

  return [search, setSearchQuery];
}

export default useSearchDebounce
